import { connect } from 'react-redux';
import { fetchReviewsByStationId } from '../../actions/reviews';
import { REVIEWS_PAGE_SIZE } from '../../constants/reviewRatings';
import { buildCachedReviewsKey, getReviewsByStationIdFromReducer } from '../../reducers/reviews';
import Reviews from './Reviews';
import getErrorMessage from '../../../lib/utils/getErrorMessage';

function mapStateToProps({ stationInfo, reviews }, ownProps) {
  const { stationId } = ownProps;
  const station = stationInfo.stationsById[stationId];
  const hasMoreReviews = !reviews.pagingByStationId[stationId]?.isLastPage || false;


  return {
    isFetching: reviews.isFetching,
    hasFetched: reviews.cachedReviewsKeys.includes(buildCachedReviewsKey(stationId, REVIEWS_PAGE_SIZE)),
    reviews: ownProps.reviews || getReviewsByStationIdFromReducer(stationId, reviews),
    hasMoreReviews,
    rating: station && station.star_rating,
    error: getErrorMessage(reviews.error, 'There was an error loading reviews'),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchReviewsByStationId: (stationId, page) => dispatch(fetchReviewsByStationId(stationId, page)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Reviews);
